import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const CustomFormPage = lazyWithRetry(() => import("@/features/custom-forms/pages/CustomFormPage"));
const CustomFormsListPage = lazyWithRetry(() => import("@/features/custom-forms/pages/CustomFormsListPage"));

export const CUSTOM_FORMS_LIST_PATH = "/formulaires";
export const CUSTOM_FORM_PATH = "/formulaires/:slug";

export const getCustomFormPath = (slug: string): string => `${CUSTOM_FORMS_LIST_PATH}/${slug}`;

const customFormsRoutes: RouteConfig[] = [
  {
    path: CUSTOM_FORMS_LIST_PATH,
    element: <CustomFormsListPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CUSTOM_FORM_PATH,
    element: <CustomFormPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default customFormsRoutes;
